/* ========================================= */
/* NUNO MAIN JAVASCRIPT                      */
/* ========================================= */

document.addEventListener('DOMContentLoaded', () => {
  initParallaxTextEffect();
  initDynamicMonth();
  initRecommendationsSlider();
  initCategoryFilters();
  initProductPage();
});

/**
 * Parses all <span> tags within the parallax text and highlights them
 * sequentially based on scroll progress through the section.
 */
function initParallaxTextEffect() {
  const section = document.getElementById('nunoParallax');
  const textContainer = section ? section.querySelector('.nuno-parallax__text') : null;

  if (!section || !textContainer) return;

  const spans = Array.from(textContainer.querySelectorAll('span'));
  if (spans.length === 0) return;

  // Optimize scroll event listener with throttling/passive
  const handleScroll = () => {
    const rect = section.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    let startOffset = windowHeight * 0.3;
    let endOffset = windowHeight * 0.6;

    let progress = (windowHeight - rect.top - startOffset) / (rect.height + windowHeight - startOffset - endOffset);

    progress = Math.max(0, Math.min(1, progress));
    const activeWordsCount = Math.floor(progress * spans.length);

    spans.forEach((span, index) => {
      if (index < activeWordsCount) {
        span.style.color = "rgba(255, 255, 255, 1)";
      } else {
        span.style.color = "rgba(255, 255, 255, 0.3)";
      }
    });

    // Background Image Parallax (moves slower than text)
    // Calculate distance from center of screen for smoother offset
    const offset = window.scrollY - section.offsetTop;
    // Positive offset means scrolling down past it, move bg down slightly
    section.style.backgroundPositionY = `${offset * 0.4}px`;
  };

  window.addEventListener('scroll', handleScroll, { passive: true });
  handleScroll();
}

/**
 * Updates the recommendations title with the current month in Polish
 */
function initDynamicMonth() {
  const monthSpan = document.getElementById('currentMonth');
  if (monthSpan) {
    const months = ['styczeń', 'luty', 'marzec', 'kwiecień', 'maj', 'czerwiec', 'lipiec', 'sierpień', 'wrzesień', 'październik', 'listopad', 'grudzień'];
    const currentMonthIndex = new Date().getMonth();
    monthSpan.textContent = months[currentMonthIndex];
  }
}

/**
 * Enables mouse dragging/swiping and button navigation for the product slider.
 * Arrows and drag release always land on a card edge (same alignment as native snap on mobile).
 */
function initRecommendationsSlider() {
  const slider = document.getElementById('nunoSlider');
  if (!slider) return;

  const btnPrev = document.querySelector('.nuno-slider-btn--prev');
  const btnNext = document.querySelector('.nuno-slider-btn--next');
  const controls = document.querySelector('.nuno-recommendations__controls');

  // Scroll positions at which a card starts at the slider's (scroll-padding adjusted) left edge
  function snapPositions() {
    const sliderRect = slider.getBoundingClientRect();
    const padding = parseFloat(getComputedStyle(slider).scrollPaddingLeft) || 0;
    const max = slider.scrollWidth - slider.clientWidth;
    const positions = Array.from(slider.querySelectorAll('.nuno-product')).map((card) => {
      const left = card.getBoundingClientRect().left - sliderRect.left + slider.scrollLeft - padding;
      return Math.round(Math.min(Math.max(left, 0), max));
    });
    return [...new Set(positions)].sort((a, b) => a - b);
  }

  function scrollToPosition(left) {
    slider.scrollTo({ left, behavior: 'smooth' });
  }

  function step(direction) {
    const current = slider.scrollLeft;
    const positions = snapPositions();
    const target = direction > 0
      ? positions.find((p) => p > current + 2)
      : [...positions].reverse().find((p) => p < current - 2);
    scrollToPosition(target !== undefined ? target : (direction > 0 ? positions[positions.length - 1] : 0));
  }

  function updateControls() {
    const max = slider.scrollWidth - slider.clientWidth;
    if (controls) controls.style.visibility = max > 2 ? '' : 'hidden';
    if (btnPrev) btnPrev.disabled = slider.scrollLeft <= 2;
    if (btnNext) btnNext.disabled = slider.scrollLeft >= max - 2;
  }

  if (btnPrev) btnPrev.addEventListener('click', () => step(-1));
  if (btnNext) btnNext.addEventListener('click', () => step(1));

  let ticking = false;
  slider.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => { updateControls(); ticking = false; });
  }, { passive: true });
  window.addEventListener('resize', updateControls);
  updateControls();

  // Mouse dragging (touch devices keep native scrolling + CSS snap)
  let isDown = false;
  let isDragging = false;
  let startX = 0;
  let startScroll = 0;
  let restoreSnapTimer;

  slider.addEventListener('dragstart', (e) => e.preventDefault());

  slider.addEventListener('mousedown', (e) => {
    if (e.button !== 0) return;
    isDown = true;
    isDragging = false;
    startX = e.pageX;
    startScroll = slider.scrollLeft;
    clearTimeout(restoreSnapTimer);
    slider.style.scrollSnapType = 'none'; // snap fights manual scrollLeft updates and causes jumps
    slider.style.scrollBehavior = 'auto';
    slider.style.cursor = 'grabbing';
  });

  slider.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    const walk = e.pageX - startX;
    if (Math.abs(walk) > 5) isDragging = true;
    if (!isDragging) return;
    e.preventDefault();
    slider.scrollLeft = startScroll - walk;
  });

  function endDrag() {
    if (!isDown) return;
    isDown = false;
    slider.style.cursor = 'grab';
    slider.style.scrollBehavior = '';

    // Land on the nearest card edge, leaning towards the drag direction
    const moved = slider.scrollLeft - startScroll;
    const positions = snapPositions();
    let target = positions.reduce((best, p) => (Math.abs(p - slider.scrollLeft) < Math.abs(best - slider.scrollLeft) ? p : best), positions[0] || 0);
    if (Math.abs(moved) > 40) {
      const directional = moved > 0
        ? positions.find((p) => p > startScroll + 2)
        : [...positions].reverse().find((p) => p < startScroll - 2);
      if (directional !== undefined && Math.abs(directional - slider.scrollLeft) < Math.abs(target - slider.scrollLeft) + 80) {
        target = directional;
      }
    }
    scrollToPosition(target);
    restoreSnapTimer = setTimeout(() => { slider.style.scrollSnapType = ''; }, 450);
  }

  slider.addEventListener('mouseup', endDrag);
  slider.addEventListener('mouseleave', endDrag);

  // A drag must not open the product link under the cursor
  slider.addEventListener('click', (e) => {
    if (isDragging) {
      e.preventDefault();
      e.stopPropagation();
      isDragging = false;
    }
  }, true);
}

/**
 * Offcanvas Cart / Checkout Drawer logic
 */
function initCartDrawer() {
  const cartButtons = document.querySelectorAll('.nuno-cart, a[href="#cart"], a[href="/basketedit.php"]');
  const cartDrawer = document.querySelector('.nuno-cart-drawer');
  const cartOverlay = document.querySelector('.nuno-cart-overlay');
  const cartClose = document.querySelector('.nuno-cart__close');

  if (!cartDrawer || !cartOverlay) return;

  window.openCartDrawer = function (e) {
    if (e) e.preventDefault();
    cartDrawer.classList.add('is-open');
    cartOverlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  };

  window.closeCartDrawer = function () {
    cartDrawer.classList.remove('is-open');
    cartOverlay.classList.remove('is-active');
    document.body.style.overflow = '';
  };

  cartButtons.forEach(btn => btn.addEventListener('click', window.openCartDrawer));
  if (cartClose) cartClose.addEventListener('click', window.closeCartDrawer);
  cartOverlay.addEventListener('click', window.closeCartDrawer);
}
window.initCartDrawer = initCartDrawer;

/**
 * Navbar Expandable Search logic
 */
function initNavbarSearch() {
  const searchWrapper = document.querySelector('.nuno-nav__search-wrapper');
  const searchBtn = document.querySelector('.nuno-nav__search-btn');
  const searchInput = document.querySelector('.nuno-nav__search-input');

  searchBtn.addEventListener('click', (e) => {
    const isActive = searchWrapper.classList.contains('is-active');

    if (!isActive) {
      e.preventDefault();
      searchWrapper.classList.add('is-active');
      // Small delay to allow CSS transition to start before focusing
      setTimeout(() => searchInput.focus(), 50);
    } else {
      if (searchInput.value.trim() === '') {
        e.preventDefault();
        searchWrapper.classList.remove('is-active');
        searchWrapper.classList.remove('has-text');
      }
      // Native form submission will happen here if value is not empty
    }
  });

  searchInput.addEventListener('input', () => {
    if (searchInput.value.trim() !== '') {
      searchWrapper.classList.add('has-text');
    } else {
      searchWrapper.classList.remove('has-text');
    }
  });

  // Close when clicking outside the wrapper
  document.addEventListener('click', (e) => {
    if (!searchWrapper.contains(e.target)) {
      searchWrapper.classList.remove('is-active');
      searchWrapper.classList.remove('has-text');
    }
  });
}

/**
 * Mobile Menu Offcanvas logic
 */
function initMobileMenu() {
  const menuBtn = document.getElementById('nunoMobileMenuBtn');
  const menuDrawer = document.querySelector('.nuno-mobile-menu-drawer');
  const menuOverlay = document.querySelector('.nuno-mobile-menu-overlay');
  const menuClose = document.querySelector('.nuno-mobile-menu__close');

  if (!menuBtn || !menuDrawer || !menuOverlay) return;

  function openMenu(e) {
    if (e) e.preventDefault();
    menuDrawer.classList.add('is-open');
    menuOverlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    menuDrawer.classList.remove('is-open');
    menuOverlay.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  menuBtn.addEventListener('click', openMenu);
  if (menuClose) menuClose.addEventListener('click', closeMenu);
  menuOverlay.addEventListener('click', closeMenu);

  // Mobile Accordion Logic
  const accordions = document.querySelectorAll('.nuno-mobile-menu__accordion-btn');
  accordions.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const parentItem = btn.closest('.nuno-mobile-menu__item');

      // Close other open accordions optionally (for a cleaner experience)
      const siblings = document.querySelectorAll('.nuno-mobile-menu__item.is-open');
      siblings.forEach(sib => {
        if (sib !== parentItem) {
          sib.classList.remove('is-open');
        }
      });

      parentItem.classList.toggle('is-open');
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initCartDrawer();
  initNavbarSearch();
  initMobileMenu();
  initGlobalAjaxCart();
});

/**
 * Initializes Category List Filter Accordions and Mobile Sidebar
 */
function initCategoryFilters() {
  const filterGroups = document.querySelectorAll('.nuno-filter-group__toggle');

  // Accordion Logic
  filterGroups.forEach(toggle => {
    toggle.addEventListener('click', () => {
      const group = toggle.closest('.nuno-filter-group');
      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

      toggle.setAttribute('aria-expanded', !isExpanded);
      if (isExpanded) {
        group.classList.remove('is-open');
      } else {
        group.classList.add('is-open');
      }
    });
  });

  // Mobile Sidebar Logic
  const mobileOpenBtn = document.getElementById('nunoMobileFilterBtn');
  const mobileCloseBtn = document.querySelector('.nuno-filters__mobile-close');
  const sidebar = document.getElementById('nunoFiltersSidebar');

  if (mobileOpenBtn && sidebar) {
    mobileOpenBtn.addEventListener('click', () => {
      sidebar.classList.add('is-open-mobile');
      document.body.style.overflow = 'hidden'; // prevent bg scroll
    });
  }

  if (mobileCloseBtn && sidebar) {
    mobileCloseBtn.addEventListener('click', () => {
      sidebar.classList.remove('is-open-mobile');
      document.body.style.overflow = '';
    });
  }
}

/**
 * Product Page Interactivity:
 * Weight selector, Grind selector, Quantity control, Gallery thumbnails
 */
function initProductPage() {
  // Weight Selector
  const weightSelector = document.getElementById('nunoWeightSelector');
  if (weightSelector) {
    weightSelector.querySelectorAll('.nuno-weight-selector__tile').forEach(tile => {
      tile.addEventListener('click', () => {
        weightSelector.querySelectorAll('.nuno-weight-selector__tile').forEach(t => {
          t.classList.remove('is-active');
          t.setAttribute('aria-pressed', 'false');
        });
        tile.classList.add('is-active');
        tile.setAttribute('aria-pressed', 'true');
      });
    });
  }

  // Grind Selector
  const grindSelector = document.getElementById('nunoGrindSelector');
  if (grindSelector) {
    grindSelector.querySelectorAll('.nuno-grind-selector__tile').forEach(tile => {
      tile.addEventListener('click', () => {
        grindSelector.querySelectorAll('.nuno-grind-selector__tile').forEach(t => {
          t.classList.remove('is-active');
          t.setAttribute('aria-pressed', 'false');
        });
        tile.classList.add('is-active');
        tile.setAttribute('aria-pressed', 'true');
      });
    });
  }

  // Quantity Control
  const qtyVal = document.getElementById('nunoQtyVal');
  const qtyMinus = document.getElementById('nunoQtyMinus');
  const qtyPlus = document.getElementById('nunoQtyPlus');
  if (qtyVal && qtyMinus && qtyPlus) {
    let qty = 1;
    qtyMinus.addEventListener('click', () => { if (qty > 1) { qty--; qtyVal.textContent = qty; } });
    qtyPlus.addEventListener('click', () => { qty++; qtyVal.textContent = qty; });
  }

  // Gallery Thumbnails
  const mainImg = document.getElementById('nunoMainImg') || document.querySelector('#nunoGalleryMain img') || document.querySelector('.nuno-product-gallery__img');
  const thumbs = document.querySelectorAll('.nuno-product-gallery__thumb');
  if (mainImg && thumbs.length) {
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        const newSrc = thumb.getAttribute('data-img');
        const fallback = thumb.getAttribute('data-fallback');
        if (newSrc) {
          mainImg.src = newSrc;
          mainImg.removeAttribute('srcset');
          if (fallback) mainImg.setAttribute('data-fallback', fallback);
        }
        thumbs.forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });

    // Opóźniony pre-cache w tle TYLKO po pełnym załadowaniu strony i w czasie bezczynności CPU/sieci (idle)
    const runIdlePreload = () => {
      const preloadFn = () => {
        thumbs.forEach(thumb => {
          const src = thumb.getAttribute('data-img');
          if (src) {
            const img = new Image();
            img.src = src;
          }
        });
      };

      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(preloadFn, { timeout: 4000 });
      } else {
        setTimeout(preloadFn, 2000);
      }
    };

    if (document.readyState === 'complete') {
      setTimeout(runIdlePreload, 1500);
    } else {
      window.addEventListener('load', () => setTimeout(runIdlePreload, 1500), { once: true });
    }
  }

  // Init brewing guide if present on page
  initBrewingGuide();
}

/**
 * Brewing Guide — method switcher with per-method recipe data.
 * Authentic preparation parameters for Honduras 100% Arabica.
 */
function initBrewingGuide() {
  var brewMethods = document.getElementById('nunoBrewMethods');
  if (!brewMethods) return;

  var recipes = {
    chemex: {
      kawa: '30g', mielenie: 'Gruboziarniste (28 klik)', woda: '500ml / 94°C',
      preinfuzja: '60ml / 45s', czas: '4:00–4:30',
      instrukcja: 'Zalej 60ml, poczekaj 45s (bloom). Dolewaj spiralnie co 60s do 500ml. Pokręć delikatnie Chemexem po ostatnim zalaniu.'
    },
    v60: {
      kawa: '18g', mielenie: '23. klik (Comandante)', woda: '300ml / 96°C',
      preinfuzja: '60ml / 40s', czas: '2:45–3:00',
      instrukcja: 'Zalania do 150/300ml w 0:40 i 1:15, koniec w 1:45. Po każdym zalaniu zamieszać dripperem dwa razy.'
    },
    aeropress: {
      kawa: '15g', mielenie: 'Średniogruboziarniste', woda: '250ml / 88°C',
      preinfuzja: '30ml / 30s', czas: '2:00–2:30',
      instrukcja: 'Postaw odwrotnie. Bloom 30ml / 30s. Dodaj resztę wody, zamieszaj 5x. Po 90s obróć i tłocz powoli przez 30s.'
    },
    frenchpress: {
      kawa: '35g', mielenie: 'Gruboziarniste', woda: '500ml / 93°C',
      preinfuzja: 'Brak', czas: '4:00',
      instrukcja: 'Zalej całą wodą, zamieszaj. Przykryj i odczekaj 4 minuty. Powoli naciśnij tłok. Przelej natychmiast by uniknąć nadekstrakcji.'
    },
    kawiarka: {
      kawa: '20g', mielenie: 'Drobnoziarniste', woda: '200ml / Zimna',
      preinfuzja: 'Brak', czas: '5:00–6:00',
      instrukcja: 'Napełnij dolną komorę zimną wodą. Wsyp kawę do sitka bez ubijania. Gotuj na niskim ogniu z otwartą pokrywą — zdejmij gdy zacznie parzyć.'
    },
    syfon: {
      kawa: '25g', mielenie: 'Średniogruboziarniste', woda: '350ml / 100°C',
      preinfuzja: 'Brak', czas: '3:30–4:00',
      instrukcja: 'Gdy woda uniesie się do górnej komory, dodaj kawę i zamieszaj. Gotuj 90s, zdejmij ciepło — kawa spłynie przez filtr.'
    },
    clever: {
      kawa: '20g', mielenie: 'Średniogruboziarniste', woda: '300ml / 95°C',
      preinfuzja: '50ml / 35s', czas: '3:30',
      instrukcja: 'Bloom 50ml / 35s. Uzupełnij do 300ml, zamieszaj. Przykryj na 2:30. Postaw na kubku — kawa spłynie przez zawór w 30s.'
    }
  };

  var btns = brewMethods.querySelectorAll('.nuno-brewing-method');
  var pKawa = document.getElementById('brewParamKawa');
  var pMielenie = document.getElementById('brewParamMielenie');
  var pWoda = document.getElementById('brewParamWoda');
  var pPreinfuzja = document.getElementById('brewParamPreinfuzja');
  var pCzas = document.getElementById('brewParamCzas');
  var pInstrukcja = document.getElementById('brewInstructions');

  function applyRecipe(method) {
    var r = recipes[method];
    if (!r) return;
    if (pKawa) pKawa.textContent = r.kawa;
    if (pMielenie) pMielenie.textContent = r.mielenie;
    if (pWoda) pWoda.textContent = r.woda;
    if (pPreinfuzja) pPreinfuzja.textContent = r.preinfuzja;
    if (pCzas) pCzas.textContent = r.czas;
    if (pInstrukcja) pInstrukcja.textContent = r.instrukcja;
  }

  btns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      btns.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      applyRecipe(btn.getAttribute('data-method'));
    });
  });
}

/**
 * Global AJAX Add to Cart for forms with class .nuno-card-btn--cart-form
 */
function initGlobalAjaxCart() {
  document.body.addEventListener('submit', function (e) {
    const form = e.target.closest('.nuno-card-btn--cart-form');
    if (!form) return;

    e.preventDefault();
    const formData = new FormData(form);

    const btn = form.querySelector('button[type="submit"]');
    const originalHtml = btn ? btn.innerHTML : '';
    if (btn) {
      btn.innerHTML = 'Dodawanie...';
      btn.disabled = true;
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      body: formData
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(res => {
        if (window.refreshCartDrawer) {
          window.refreshCartDrawer().then(() => {
            if (window.openCartDrawer) {
              window.openCartDrawer();
            }
          });
        }
      })
      .catch(err => {
        console.error('AJAX add to cart error:', err);
        alert('Nie udało się dodać produktu do koszyka. Spróbuj ponownie.');
      })
      .finally(() => {
        if (btn) {
          btn.innerHTML = originalHtml;
          btn.disabled = false;
        }
      });
  });
}

/**
 * Global AJAX Refresh of the Cart Drawer markup and badge counts
 */
window.refreshCartDrawer = function () {
  return fetch(window.Shopify.routes.root + 'cart.js')
    .then(res => res.json())
    .then(cartState => {
      document.querySelectorAll('.nuno-cart__badge, .basket_count').forEach(badge => {
        badge.textContent = cartState.item_count;
      });
      return fetch(window.Shopify.routes.root + 'cart?view=ajax');
    })
    .then(response => response.text())
    .then(htmlText => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlText, 'text/html');

      const newDrawer = doc.querySelector('.nuno-cart-drawer');
      const oldDrawer = document.querySelector('.nuno-cart-drawer');
      if (newDrawer && oldDrawer) {
        oldDrawer.innerHTML = newDrawer.innerHTML;
      }

      const newOverlay = doc.querySelector('.nuno-cart-overlay');
      const oldOverlay = document.querySelector('.nuno-cart-overlay');
      if (newOverlay && oldOverlay) {
        oldOverlay.innerHTML = newOverlay.innerHTML;
      }
    })
    .finally(() => {
      setTimeout(() => {
        if (typeof window.initCartDrawer === 'function') {
          window.initCartDrawer();
        }
        if (typeof window.bindCartInputs === 'function') {
          window.bindCartInputs();
        }
      }, 50);
    });
};

